import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { IPostStoredChatMessageRequest } from './apiChatMessages.models';
import { API_CHAT_MESSAGES_URL } from './apiChatMessagesUrl.constants';
import { UtilsService } from '../../services/utils/utils.service';
import { EnvironmentService } from '../../services/enviroment/environment.service';

@Injectable({
  providedIn: 'root',
})
export class ApiChatMessagesService extends ApiService {
  private hasAuthBasic: boolean;

  constructor(
    utils: UtilsService,
    private readonly http: HttpClient,
    private readonly environmentService: EnvironmentService
  ) {
    super(utils);
    this.hasAuthBasic = !!environmentService.data.authorizationBasic;
  }

  getChatMessages(attendantId: string): Observable<any> {
    const apiInstance = this.getApiInstance(
      API_CHAT_MESSAGES_URL.GET_CHAT_MESSSAGES
    );
    apiInstance.params['attendantId'].value = attendantId;

    const url = this.getApiUrl(
      this.environmentService.data.apiUrl,
      apiInstance
    );
    const authorizationHeader = this.getAuthorizationHeader(
      apiInstance.security.authorizationBasic
    );

    return this.hasAuthBasic
      ? this.http.get(url, authorizationHeader)
      : this.http.get(url);
  }

  getChatFile(attendantId: string, fileId: number): Observable<any> {
    const apiInstance = this.getApiInstance(
      API_CHAT_MESSAGES_URL.GET_CHAT_FILE
    );
    apiInstance.params['attendantId'].value = attendantId;
    apiInstance.params['fileId'].value = fileId;

    const url = this.getApiUrl(
      this.environmentService.data.apiUrl,
      apiInstance
    );
    const authorizationHeader = this.getAuthorizationHeader(
      apiInstance.security.authorizationBasic
    );

    return this.hasAuthBasic
      ? this.http.get(url, authorizationHeader)
      : this.http.get(url);
  }

  postMessage(body: IPostStoredChatMessageRequest): Observable<any> {
    const apiInstance = this.getApiInstance(
      API_CHAT_MESSAGES_URL.POST_CHAT_MESSSAGES
    );

    const url = this.getApiUrl(
      this.environmentService.data.apiUrl,
      apiInstance
    );
    const authorizationHeader = this.getAuthorizationHeader(
      apiInstance.security.authorizationBasic
    );

    return this.hasAuthBasic
      ? this.http.post(url, body, authorizationHeader)
      : this.http.post(url, body);
  }

  private getAuthorizationHeader(authorizationBasicCode: string): any {
    return { headers: { authorization: authorizationBasicCode } };
  }
}
